// src/components/ADLPopup.js
import React, { useState } from 'react';

function ADLPopup({ token, onSelectAdl, onClose }) {
  const [showSubOptions, setShowSubOptions] = useState(null);

  const timeLabel = token?.label || 'Select Time Slot';

  // ADLs with icons
  const adls = [
    { name: 'Eating', icon: 'restaurant' },
    { name: 'Watching TV', icon: 'tv' },
    { name: 'Exercising', icon: 'directions_run' },
    { name: 'Cooking', icon: 'kitchen' },
    { name: 'Bathing', icon: 'bathtub' },
    { name: 'Washing_dishes', icon: 'local_laundry_service' },
    { name: 'Medication', icon: 'local_hospital' },
    { name: 'Toileting_continence', icon: 'wc' },
    { name: 'Dressing', icon: 'checkroom' },
    { name: 'Hygiene', icon: 'clean_hands' },
    { name: 'Mobility', icon: 'directions_walk' },
    { name: 'Sleep_rest', icon: 'bed' },
    { name: 'Household', icon: 'home_work' },
    { name: 'Transportation', icon: 'directions_car' },
    { name: 'Leisure_social', icon: 'people_outline' },
  ];

  // Sub-options with icons
  const eatingSubOptions = [
    { name: 'Eat_breakfast', icon: 'restaurant' },
    { name: 'Eat_lunch', icon: 'restaurant' },
    { name: 'Eat_dinner', icon: 'restaurant' },
    { name: 'Kitchen_snack', icon: 'restaurant' },
  ];

  const cookingSubOptions = [
    { name: 'Cook_breakfast', icon: 'kitchen' },
    { name: 'Cook_lunch', icon: 'kitchen' },
    { name: 'Cook_dinner', icon: 'kitchen' },
  ];

  const washingDishesSubOptions = [
    { name: 'Washing_breakfast_dishes', icon: 'local_laundry_service' },
    { name: 'Washing_lunch_dishes', icon: 'local_laundry_service' },
    { name: 'Washing_dinner_dishes', icon: 'local_laundry_service' },
  ];

  const medicationSubOptions = [
    { name: 'Morning_meds', icon: 'local_hospital' },
    { name: 'Evening_meds', icon: 'local_hospital' },
  ];

  const toiletingContinenceSubOptions = [
    { name: 'Toilet', icon: 'wc' },
    { name: 'Continence', icon: 'wc' },
  ];

  const hygieneSubOptions = [
    { name: 'Personal_hygiene', icon: 'clean_hands' },
  ];

  const mobilitySubOptions = [
    { name: 'Step_in', icon: 'directions_walk' },
    { name: 'Step_out', icon: 'directions_walk' },
    { name: 'Enter_home', icon: 'directions_walk' },
    { name: 'Leave_home', icon: 'directions_walk' },
  ];

  const sleepRestSubOptions = [
    { name: 'C_to_bed', icon: 'bed' },
    { name: 'Go_to_sleep', icon: 'bed' },
    { name: 'Sleep', icon: 'bed' },
    { name: 'Sleep_out_of_bed', icon: 'bed' },
    { name: 'P_bedroom', icon: 'bed' },
  ];

  const householdSubOptions = [
    { name: 'Shopping', icon: 'shopping_cart' },
    { name: 'Laundry', icon: 'local_laundry_service' },
    { name: 'Managing_finances', icon: 'account_balance_wallet' },
  ];

  const leisureSocialSubOptions = [
    { name: 'Phone', icon: 'phone' },
    { name: 'Work_at_table', icon: 'desk' },
    { name: 'Watch_TV', icon: 'tv' },
    { name: 'Electronics_Tablet_smartphone', icon: 'smartphone' },
    { name: 'Read', icon: 'book' },
    { name: 'Relax', icon: 'spa' },
    { name: 'Other_activity', icon: 'more_horiz' },
  ];

  const handleAdlClick = (adlName) => {
    const adl = adls.find(a => a.name === adlName);
    if (!adl) return;

    const subOptions = {
      Eating: eatingSubOptions,
      Cooking: cookingSubOptions,
      Washing_dishes: washingDishesSubOptions,
      Medication: medicationSubOptions,
      Toileting_continence: toiletingContinenceSubOptions,
      Hygiene: hygieneSubOptions,
      Mobility: mobilitySubOptions,
      Sleep_rest: sleepRestSubOptions,
      Household: householdSubOptions,
      Leisure_social: leisureSocialSubOptions,
    }[adlName];

    if (subOptions) {
      setShowSubOptions(adlName);
    } else {
      onSelectAdl(adlName);
    }
  };

  const handleSubOptionClick = (subOption) => {
    onSelectAdl(subOption);
  };

  const handleBackClick = () => {
    setShowSubOptions(null);
  };

  return (
    <div className="adl-sidebar">
      <div className="adl-sidebar-header">
        <h3>Select ADL for</h3>
        <p className="adl-sidebar-time">{timeLabel}</p>
      </div>

      <div className="adl-sidebar-content">
        {showSubOptions ? (
          <>
            <div className="adl-buttons-grid">
              {(showSubOptions === 'Eating' ? eatingSubOptions :
                showSubOptions === 'Cooking' ? cookingSubOptions :
                showSubOptions === 'Washing_dishes' ? washingDishesSubOptions :
                showSubOptions === 'Medication' ? medicationSubOptions :
                showSubOptions === 'Toileting_continence' ? toiletingContinenceSubOptions :
                showSubOptions === 'Hygiene' ? hygieneSubOptions :
                showSubOptions === 'Mobility' ? mobilitySubOptions :
                showSubOptions === 'Sleep_rest' ? sleepRestSubOptions :
                showSubOptions === 'Household' ? householdSubOptions :
                leisureSocialSubOptions).map(sub => (
                <button 
                  key={sub.name} 
                  className="adl-button" 
                  onClick={() => handleSubOptionClick(sub.name)}
                >
                  <span className="material-icons" style={{ marginRight: '10px', fontSize: '20px' }}>
                    {sub.icon}
                  </span>
                  {sub.name.replace('_', ' ')}
                </button>
              ))}
            </div>
            <button className="adl-back-button" onClick={handleBackClick}>
              <span className="material-icons" style={{ marginRight: '10px' }}>arrow_back</span>
              Back
            </button>
          </>
        ) : (
          <div className="adl-buttons-grid">
            {adls.map(adl => (
              <button 
                key={adl.name} 
                className="adl-button" 
                onClick={() => handleAdlClick(adl.name)}
              >
                <span className="material-icons" style={{ marginRight: '10px', fontSize: '20px' }}>
                  {adl.icon}
                </span>
                {adl.name.replace('_', ' ')}
              </button>
            ))}
          </div>
        )}
      </div>

      <button className="close-sidebar" onClick={onClose}>Close</button>
    </div>
  );
}

export default ADLPopup;